import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import HomePage from './pages/HomePage/HomePage';
import Footer from './components/Footer/Footer';
import './App.css';

// Lazy load pages for better performance
const FindDoctorsPage = lazy(() => import('./pages/FindDoctorsPage/FindDoctorsPage'));
const BookAppointmentPage = lazy(() => import('./pages/BookAppointmentPage/BookAppointmentPage'));
const TelemedicinePage = lazy(() => import('./pages/TelemedicinePage/TelemedicinePage'));
const PatientPortalPage = lazy(() => import('./pages/PatientPortalPage/PatientPortalPage'));
const EmergencyPage = lazy(() => import('./pages/EmergencyPage/EmergencyPage'));
const LoginPage = lazy(() => import('./pages/LoginPage/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage/RegisterPage'));

// Loading component
const PageLoader = () => (
  <div className="page-loader">
    <div className="spinner"></div>
    <p>Loading...</p>
  </div>
);

function App() {
  return (
    <div className="App">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
                 <Suspense fallback={<PageLoader />}>
                   <Routes>
                     <Route path="/" element={<HomePage />} />
                     <Route path="/find-doctors" element={<FindDoctorsPage />} />
                     <Route path="/book-appointment" element={<BookAppointmentPage />} />
                     <Route path="/telemedicine" element={<TelemedicinePage />} />
                     <Route path="/patient-portal" element={<PatientPortalPage />} />
                     <Route path="/emergency" element={<EmergencyPage />} />
                     <Route path="/login" element={<LoginPage />} />
                     <Route path="/register" element={<RegisterPage />} />
                   </Routes>
                 </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
